export enum SearchRankTypeEnum {
  bestPrice = 1,
  portion = 2
}
